import React from 'react'
import PropTypes from 'prop-types'
import { MenuItem, SelectField } from 'material-ui'

const FilterMenu = ({
  data,
  labelStyles,
  labelText,
  menuItemText,
  name,
  onSelectionChange,
  selectStyles,
  value,
}) => {
  const onChange = (event, index, eventVal) => {
    onSelectionChange(eventVal, name)
  }
  return data && !!data.length ? (
    <div className={selectStyles}>
      <span className={labelStyles}>{labelText}: </span>
      <SelectField value={value} onChange={onChange}>
        <MenuItem value={''} primaryText={menuItemText} />
        {data.map(item => (
          <MenuItem
            key={`${item.name}–${item.id}`}
            value={item.id}
            name={name}
            primaryText={item.name ? item.name : item.description}
          />
        ))}
      </SelectField>
    </div>
  ) : null
}

FilterMenu.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),
  ),
  labelText: PropTypes.string,
  labelStyles: PropTypes.string,
  menuItemText: PropTypes.string.isRequired,
  name: PropTypes.string,
  onSelectionChange: PropTypes.func.isRequired,
  selectStyles: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.element,
    PropTypes.object,
  ]),
}

export default FilterMenu



// WEBPACK FOOTER //
// ./src/components/sitewide/FilterMenu/index.js